export default __webpack_public_path__ + "static/media/IMG_0433-2.b7906fa7.jpg";